import { useOutletContext, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';
import {
  isComprasFrontendPath,
  canLimitedUserMutateWarehouseGuides,
  canLimitedUserMutateKardex,
  canLimitedUserMutateSunatMappings,
  canLimitedUserMutateVentas,
} from '../utils/limitedUserAccess';

/**
 * false si el usuario es limitado fuera de Compras, Ventas (POS), guías, kardex o mapeos SUNAT.
 */
export function useCanMutate() {
  const location = useLocation();
  const ctx = useOutletContext();
  const user = authService.getCurrentUser();

  if (user?.role === 'limitado') {
    return (
      isComprasFrontendPath(location.pathname)
      || canLimitedUserMutateVentas(location.pathname, user)
      || canLimitedUserMutateWarehouseGuides(location.pathname, user)
      || canLimitedUserMutateKardex(location.pathname, user)
      || canLimitedUserMutateSunatMappings(location.pathname, user)
    );
  }
  if (ctx?.readOnly === true) {
    return false;
  }
  return true;
}

export function isLimitedReadOnlyUser(user) {
  return user?.role === 'limitado';
}
